<template>
<div class="chapter">
<div class="inner_page">
<h2 class="TOC-FBMHD">Tools &amp; equipment</h2>
<p class="SECTION-INTRO1">Before you start, it’s a good idea to check you have everything to hand that you might need. Included in this section is a list of essential equipment for making and baking your cupcake sponge bases and to whip up your frostings; a basic decorating toolbox; and key specialist tools. Don’t feel you need to have all the latter kit to create fun cupcakes, but if you are making a large quantity or get really hooked, these are the items I find really useful. Specific tools required beyond the basics are listed under ‘you will need’ at the start of each project.</p>
<h4 class="MLAHD">Baking essentials</h4>
<ul>
<li>Kitchen scales/measuring cups and measuring spoons – for accurately weighing ingredients</li>
<li>Electric stand mixer with paddle attachment (flat beater) – to make the sponge cake bases and toppings</li>
<li>Muffin and mini muffin trays (pans)</li>
<li>Wire rack – to cool cupcakes</li>
<li>Flexible plastic spatulas – for scraping out bowls</li>
<li>Muffin baking cases (liners) – keep a variety of the many fantastic designs available, both paper and foil, on hand for spontaneous events</li>
<li>Large disposable plastic piping (pastry) bags – for piping your mixture into cases (liners)</li>
<li>Oven thermometer – a must if unsure of your internal oven temperature</li>
<li>Microwave or double boiler – for melting chocolate</li>
<li>Plastic or glass microwave-safe bowls – for melting chocolate and butter</li>
<li>Sieve (strainer)</li>
</ul>
<div class="SBDIV">
<p class="TIP1">We usually use muffin or mini muffin-size baking cases (liners) because they are just the right size to be flat-frosted to present your cupcakes beautifully and still give a perfect amount of sponge. Smaller cupcake or fairy cake cases are not suitable for these projects.</p>
</div>
<p class="Image"><img alt="" src="images/bakemeimyours_110_fmt.jpg"/></p>
<h4 class="MLAHD">Basic decorating toolbox</h4>
<ul>
<li>Non-stick work board with non-stick mat beneath to prevent slipping – to roll out icing and cut out and model paste shapes</li>
<li>Non-stick rolling pin – for rolling out sugarpaste (rolled fondant) and flower (petal/gum) paste</li>
<li>Icing spacers – to achieve an even 3mm (<span class="fractions"><sup>1</sup>⁄<sub>8</sub></span>in) thickness</li>
<li>Large disposable plastic piping (pastry) bags, 46cm (18in) or 53cm (21in) – for piping frostings</li>
<li>Paper piping (pastry) bags – made from baking (parchment) paper for small quantities of royal icing/applying details</li>
<li>Piping tubes (tips) – fine for piping royal icing details; large for piping frosting (see <span href="#/c20#Anchor" title="Link target outside of Sample">applying frostings</span>)</li>
<li>Scissors – to snip the ends of piping (pastry) bags for tubes (tips) to fit snugly</li>
<li>Large and mini palette knives – large for buttercream; mini for cutting, turning paste and lifting paste shapes/features</li>
<li>Paintbrushes – a selection of sable (no. 3 for glue) and pony (no. 8 for glitter) are handy</li>
<li>Set of 11 circle cutters (Ateco) – nos. specified count outwards from the smallest, no. 1</li>
<li>Icing smoother – for smoothing and polishing sugarpaste (rolled fondant)</li>
<li>Sugar glue – for attaching decorative elements</li>
<li>Cocktail sticks (toothpicks) – for applying colour to icing and creating tiny indentations</li>
</ul>
<p class="Image"><img alt="" src="images/bakemeimyours_115_fmt.jpg"/></p>
<h4 class="MLAHD">Specialist decorating items</h4>
<ul>
<li>Shaped cutters – ovals, hearts, square, star, triangle</li>
<li>Kemper mini plunger cutters – 4mm (<span class="fractions"><sup>1</sup>⁄<sub>8</sub></span>in) circle and heart are used in many projects; PME blossom set comes with a foam pad to push the plunger against to cup the paste</li>
<li>Ball tool and smile tool (PME) – for adding detail to paste characters</li>
<li>Dresden tool – for scoring lines into paste and adding texture</li>
<li>Paint palette – for mixing colours and blending gold/silver lustre dust with alcohol</li>
<li>Dusting brush – for brushing lustre dust onto paste</li>
<li>Foiled cake board – for storing made-ahead paste discs</li>
</ul>
<p class="Image"><img alt="" src="images/bakemeimyours_123_fmt.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?303db4e4